import I18n from 'I18n';
import { ROUTING_RULE_TYPES, KEEP_ASSIGNEE } from './RoutingTypes';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const getSpecificUsersAndTeamsOption = () => ({
  text: I18n.text('routing-ui.routingRules.options.usersAndTeams'),
  value: ROUTING_RULE_TYPES.USERS_AND_TEAMS
});
const getAnyUserOption = (anyAvailableUser = false) => ({
  text: anyAvailableUser ? I18n.text('routing-ui.routingRules.options.anyAvailableUser') : I18n.text('routing-ui.routingRules.options.anyUser'),
  value: ROUTING_RULE_TYPES.INBOX_USERS
});
const getKeepAssigneeOption = (disabled = false) => ({
  text: I18n.text('routing-ui.routingRules.options.keepCurrentAssignment'),
  value: KEEP_ASSIGNEE,
  disabled
});
const getUnassignedOption = () => ({
  text: I18n.text('routing-ui.routingRules.options.unassigned'),
  value: ROUTING_RULE_TYPES.UNASSIGNED
});
const getContactOwnerOption = () => ({
  text: I18n.text('routing-ui.routingRules.options.contactOwner'),
  value: ROUTING_RULE_TYPES.OWNER
});
const getAiChatbotOption = () => ({
  text: I18n.text('routing-ui.routingRules.options.customerAgent'),
  badge: /*#__PURE__*/_jsx(View, {
    display: "inline-block",
    marginBlockEnd: "100",
    children: /*#__PURE__*/_jsx(AIBadge, {})
  }),
  value: ROUTING_RULE_TYPES.AI_CHATBOT
});
const getTeamsOnlyOption = () => ({
  text: I18n.text('routing-ui.routingRules.options.teamOnly'),
  value: ROUTING_RULE_TYPES.TEAMS_ONLY,
  description: I18n.text('routing-ui.routingRules.options.teamOnlyDescription')
});
export const getRoutingTypeOptions = config => {
  const {
    anyAvailableUser,
    disableKeepAssignee = false,
    showAnyUser = false,
    showKeepAssignee = false,
    showUnassigned = true,
    showOwner = true,
    showTeamsOnly = false,
    aiChatbotId
  } = config;
  const options = [];
  if (showAnyUser) {
    options.push(getAnyUserOption(anyAvailableUser));
  }
  if (showKeepAssignee) {
    options.push(getKeepAssigneeOption(disableKeepAssignee));
  }
  if (aiChatbotId) {
    options.push(getAiChatbotOption());
  }
  options.push(getSpecificUsersAndTeamsOption());
  if (showTeamsOnly) {
    options.push(getTeamsOnlyOption());
  }
  if (showOwner) {
    options.push(getContactOwnerOption());
  }
  if (showUnassigned) {
    options.push(getUnassignedOption());
  }
  return options;
};
export const getFallbackRoutingTypeOptions = () => [{
  text: I18n.text('routing-ui.routingRules.options.usersAndTeams'),
  value: ROUTING_RULE_TYPES.USERS_AND_TEAMS
}, {
  text: I18n.text('routing-ui.routingRules.options.teamOnly'),
  value: ROUTING_RULE_TYPES.TEAMS_ONLY
}, {
  text: I18n.text('routing-ui.routingRules.options.unassigned'),
  value: ROUTING_RULE_TYPES.UNASSIGNED
}];
export const getSendFromGroupOptions = () => {
  return [{
    text: I18n.text('routing-ui.routingRules.options.usersAndTeams'),
    value: ROUTING_RULE_TYPES.USERS_AND_TEAMS
  }, {
    text: I18n.text('routing-ui.routingRules.options.contactOwner'),
    value: ROUTING_RULE_TYPES.OWNER
  }, {
    text: I18n.text('routing-ui.routingRules.options.inbox'),
    value: ROUTING_RULE_TYPES.INBOX_USERS
  }];
};